define('OutSystems/ReactWidgets/Expression',["require", "exports", "tslib", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, HtmlTags_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Expression = void 0;
    var Expression = (function (_super) {
        tslib_1.__extends(Expression, _super);
        function Expression() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Expression.prototype.render = function () {
            var expressionAttributes = {
                "data-expression": "",
                className: this.props.style,
            };
            this.fillWithBuiltinProperties(expressionAttributes);
            return React.createElement(HtmlTags_1.HtmlTags.span, expressionAttributes, this.props.value);
        };
        Expression = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Expression);
        return Expression;
    }(Widget_1.Widget));
    exports.Expression = Expression;
});
//# sourceMappingURL=Expression.js.map;
